let buttons = document.querySelectorAll('.informations__heading span');
let texts = document.querySelectorAll('.informations__text');
buttons.forEach(function (button) {
  button.addEventListener('click', function () {
    buttons.forEach(function (btn) {
      btn.classList.remove('active');
    });
    button.classList.add('active');
    texts.forEach(function (txt) {
      txt.style.display = 'none';
    });
    let target = this.getAttribute('data-target');
    document.getElementById(target).style.display = 'block';
    let targetBtn = this.getAttribute('data-target-button');
    document.getElementById(targetBtn).style.display = 'block';
  });
});